var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue";
import { NButton, useNotification } from 'naive-ui';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { millisecondsToMinutes, transportIdToLetters } from '../../../../helpers/Converters';
import { formatNumber } from '../../../../helpers/Formatters';
import { key } from '../../../../store';
import BaseAssignmentTableRow from './BaseAssignmentTableRow.vue';
import TeamMarker from '../../../generic/team/TeamMarker.vue';
import ModalButton from '../../../generic/buttons/ModalButton.vue';
import TextData from '../TextData.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AssignedTransportRequestsTableRow',
    props: {
        team: {
            type: Object,
            default: null,
            required: false,
        },
        transport: {
            type: Object,
            required: true,
        },
    },
    setup: function (__props) {
        var _this = this;
        var props = __props;
        var _a = useI18n({ useScope: 'global' }), t = _a.t, locale = _a.locale;
        var store = useStore(key);
        var notification = useNotification();
        var postAllocationNotification = function (transport, team) {
            notification.create({
                title: t('assignment.table.notification.assignmentConfirmation.title'),
                description: t('assignment.table.notification.assignmentConfirmation.description', {
                    formattedTransportId: transportIdToLetters(props.transport.transportRequestId),
                    transportId: props.transport.transportRequestId,
                    teamNumber: props.team.number
                }),
                duration: 7000,
                closable: true,
            });
        };
        var allocateTransport = function (event) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.stopPropagation();
                        return [4 /*yield*/, store.dispatch('assignmentPage/unfocusTransport')];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, store.dispatch('transports/allocate', props.transport.transportRequestId)];
                    case 2:
                        _a.sent();
                        if (props.transport && props.team) {
                            postAllocationNotification(props.transport, props.team);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var reassignTransport = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, store.dispatch('assignmentPage/unfocusTransport')];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, store.dispatch('transports/reassign', props.transport.transportRequestId)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var formattedWaitingTime = computed(function () {
            if (props.transport.createdOn) {
                var waitingTime = millisecondsToMinutes(Date.now() - props.transport.createdOn);
                return formatNumber(waitingTime, locale.value);
            }
            return '';
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(BaseAssignmentTableRow, { transport: __props.transport }, {
                "awaiting-time": _withCtx(function () { return [
                    (formattedWaitingTime.value)
                        ? (_openBlock(), _createBlock(TextData, {
                            key: 0,
                            variant: "xs"
                        }, {
                            default: _withCtx(function () { return [
                                _createTextVNode(_toDisplayString(formattedWaitingTime.value) + " " + _toDisplayString(_unref(t)('assignment.table.abbreviatedMinutes')), 1 /* TEXT */)
                            ]; }),
                            _: 1 /* STABLE */
                        }))
                        : _createCommentVNode("v-if", true)
                ]; }),
                "team-icon": _withCtx(function () { return [
                    (__props.team)
                        ? (_openBlock(), _createBlock(TeamMarker, {
                            key: 0,
                            team: __props.team
                        }, null, 8 /* PROPS */, ["team"]))
                        : _createCommentVNode("v-if", true)
                ]; }),
                "first-additional-cell": _withCtx(function () { return [
                    _createVNode(ModalButton, {
                        modalMessage: _unref(t)('assignment.table.modals.reassign.message', { requestNumber: __props.transport.transportRequestId, teamNumber: __props.team.number }),
                        modalTitle: _unref(t)('assignment.table.modals.reassign.cancelAssignment'),
                        onConfirm: reassignTransport,
                        "confirm-label": _unref(t)('assignment.table.modals.reassign.reassign'),
                        "close-label": _unref(t)('assignment.table.modals.reassign.goBack')
                    }, {
                        default: _withCtx(function () { return [
                            _createTextVNode(_toDisplayString(_unref(t)('assignment.table.buttons.reassign.cancel')), 1 /* TEXT */)
                        ]; }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modalMessage", "modalTitle", "confirm-label", "close-label"])
                ]; }),
                "second-additional-cell": _withCtx(function () { return [
                    _createVNode(_unref(NButton), {
                        color: "#96BF48",
                        onClick: allocateTransport
                    }, {
                        default: _withCtx(function () { return [
                            _createTextVNode(_toDisplayString(_unref(t)('assignment.table.buttons.allocate.allocate')), 1 /* TEXT */)
                        ]; }),
                        _: 1 /* STABLE */
                    })
                ]; }),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["transport"]));
        };
    }
});
